import { render, staticRenderFns } from "./ResourceLink.vue?vue&type=template&id=241363d9"
import script from "./ResourceLink.vue?vue&type=script&lang=js"
export * from "./ResourceLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ResourceLink.vue
// module id = 333
// module chunks = 0